import { Namespace, useTranslation } from "react-i18next";

// models
export type TPrefixedFunction = (key: string) => string;

export const useTranslationWithPrefix = (
  namespace: Namespace,
  prefix: string
): TPrefixedFunction => {
  // base translation hook
  const tFunction = useTranslation(namespace).t;

  // custom translate function
  const translateWithPrefix = (key: string): string => {
    return tFunction(`${prefix}.${key}`);
  };

  // return
  return translateWithPrefix;
};
